import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class RequireActivation extends React.Component {

    componentDidMount() {
        this.props.auth.distributor.status !== 3 && this.props.history.push('/distributor/status')
    }

    render() {
        if (this.props.auth.distributor.status !== 3) {
            return (
                <>
                </>
            )
        }
        return (
            <>
                {this.props.children}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(RequireActivation))